import { InjectionToken } from '@angular/core';

import { DictionaryItem } from '@hglobal/fin-ui';
import { Observable } from 'rxjs';

import { GetTransactionsReq, GetTransactionsRes, SaveCommentReq, SaveCommentRes } from '../models';

export interface TransactionsApi {
  getTransactions(params: GetTransactionsReq, providerId: number): Observable<GetTransactionsRes>;
  saveComment(params: SaveCommentReq): Observable<SaveCommentRes>;
  getMonthlyRepYears(): Observable<DictionaryItem<string>[]>;
}

export const TRANSACTIONS_API = new InjectionToken<TransactionsApi>('TRANSACTIONS_API');
